import useTranslation from 'next-translate/useTranslation'

import Icon from '@/atoms/Icon'
import Link from '@/atoms/Link'
import DOCS from '@/organisms/Footer/data/docs'

function FooterBottomBar() {
  const { t } = useTranslation('global')

  return (
    <div className="bg-[#85cfc3]">
      <div className="box">
        <div className="relative py-6">
          <div className="flex flex-col space-y-2 text-sm text-center lg:space-y-0 lg:flex-row lg:justify-between md:px-24 xl:px-36 2xl:px-56 3xl:px-80">
            <div className="mt-4 md:mt-0">{t('copyrights')}</div>
            {DOCS.map(({ name, url }) => (
              <div key={name} className="">
                <Link className="hover:text-white/60" href={url}>
                  {t(name)}
                </Link>
              </div>
            ))}
          </div>
          <Icon
            name="footer_square"
            className="absolute w-[64px] h-[64px] top-[-32px] right-0 md:right-[calc(100%-64px)]"
          />
        </div>
      </div>
    </div>
  )
}

export default FooterBottomBar
